module.exports = __webpack_public_path__ + "img/img-flow-1.d52f3c13.jpg";